var $48778e86f0af7d7f$exports = {};
$48778e86f0af7d7f$exports = {
    "clear": `Limpar`,
    "invalid": `(inv\xe1lido)`,
    "loading": `Carregando...`,
    "noResults": `Nenhum resultado`,
    "valid": `(v\xe1lido)`
};


export {$48778e86f0af7d7f$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
